<template>
  <ob-admin-section
    type="automation"
    has-perioade
    import-headers-btn
    :xlsx="false"
    :add="false"
    :edit="false"
    :confirm-value="confirm.dialog"
    @confirmed="_cbConfirmed">

    <template slot="section-title">Sectiune Automatizari</template>

    <template slot="toolbar-title">Baza de date Automatizari</template>

    <template slot="fab" v-if="selectedTab === 0">
      <v-speed-dial
        class="ob-speed-dial"
        v-model="fab"
        absolute
        fixed
        bottom
        right
        direction="top"
        open-on-hover
        transition="scroll-y-reverse-transition"
        key="speeddial">
        <v-btn
          slot="activator"
          v-model="fab"
          color="accent"
          dark
          fab
          key="speed">
          <v-icon>mdi-menu</v-icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="success"
              @click="_cbAddPerioada">
              <v-icon>mdi-calendar-plus</v-icon>
            </v-btn>
          </span>
          <span>Adauga perioada noua</span>
        </v-tooltip>
        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="success"
              @click="_cbUpdatePerioada">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </span>
          <span>Reincearca descarcare, citire si calcul (fisierele existente deja nu vor mai fi descarcate)</span>
        </v-tooltip>
      </v-speed-dial>
    </template>
    <template slot="dialogs">
      <ob-dialog :value="perioada.dialog" :max-width="500" @close="_cbClosePerioadaDialog" key="perioada">
        <template slot="title">
          {{this.perioada.type === 'add' ? 'Adauga o noua perioada' : 'Actualizeaza perioada curenta'}}
        </template>
        <template slot="content">
          <v-alert :value="true" type="info" v-if="perioada.type === 'add'">
            Odata cu adaugarea unei perioade noi se vor copia datele de la perioada precedenta pentru: cifuri, clasificatie, indicatori, verificare.
            In acelasi timp, se va porni si descarcarea automata a fisierelor ce contin executiile la perioada.
            Se va realiza si citirea datelor din fisierele MF.
            Se vor efectua calculele pentru calsificatie si indicatori.
            Se vor genera rapoartele per cif, la perioada.
          </v-alert>
          <form ref="perioadaForm">
            <v-date-picker
              v-if="perioada.type === 'add'"
              v-model="perioada.values.quarter"
              :allowed-dates="allowedMonths"
              type="month"
              full-width
              locale="ro-RO"
              :show-current="latestPerioada"
              :title-date-format="dateToQuarter"
              :events="['2018-12-01']"
              class="mt-3 elevation-0">
            </v-date-picker>

            <v-switch
              color="primary"
              label="Se importa datele din perioada precedenta?"
              v-model="perioada.values.preluare"
              hide-details
              :readonly="perioada.type === 'edit'"
              v-if="perioada.type === 'add'">
            </v-switch>
            <v-switch
              color="primary"
              label="Se descarca executiile MF?"
              v-model="perioada.values.automation"
              hide-details
              :readonly="perioada.type === 'edit'">
            </v-switch>
            <v-switch
              color="primary"
              label="Se citesc date din executiile MF?"
              v-model="perioada.values.parse"
              hide-details
              :readonly="perioada.type === 'edit'">
            </v-switch>
            <v-switch
              color="primary"
              label="Se calculeaza clasificatia si indicatorii?"
              v-model="perioada.values.compute"
              hide-details
              :readonly="perioada.type === 'edit'">
            </v-switch>
            <v-switch
              color="primary"
              label="Se genereaza rapoartele per cif, la perioada?"
              v-model="perioada.values.reports"
              hide-details
              :readonly="perioada.type === 'edit'">
            </v-switch>
            <v-divider class="mt-3"></v-divider>
            <v-switch
              color="primary"
              label="Se sare peste datele deja existente?"
              v-model="perioada.values.skipExisting"
              hide-details
              :readonly="perioada.type === 'edit'">
            </v-switch>
          </form>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbClosePerioadaDialog">Anulare</v-btn>
          <v-btn flat color="primary" @click="_cbSavePerioada" :disabled="!perioada.values.quarter || !atLeastOneOptionSelected">Salveaza</v-btn>
        </template>
      </ob-dialog>
    </template>
  </ob-admin-section>
</template>

<script>
import AdminSection from '@/components/AdminSection';
import Dialog from '@/components/Dialog';

export default {
  name: 'automation',
  components: {
    'ob-admin-section': AdminSection,
    'ob-dialog': Dialog
  },
  data: () => ({
    type: 'automation',
    fab: null,
    confirm: {
      dialog: false,
      callback: null
    },
    selected: [],
    perioada: {
      dialog: false,
      type: 'add',
      values: {
        quarter: null,
        preluare: true,
        automation: true,
        parse: true,
        compute: true,
        reports: true,
        skipExisting: true
      }
    }
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    token () {
      return this.$store.getters['token']
    },
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    },
    latestPerioada () {
      return this.$store.getters[`${this.type}/latestPerioada`]
    },
    perioadeTabs () {
      return this.$store.getters[`${this.type}/perioadeTabs`]
    },
    selectedPerioadeTab () {
      return this.$store.getters[`${this.type}/selectedPerioadeTab`]
    },
    atLeastOneOptionSelected () {
      return this.perioada.values.automation ||
        this.perioada.values.parse ||
        this.perioada.values.compute ||
        this.perioada.values.reports
    }
  },
  methods: {
    _cbConfirmed (value) {
      if (value && this.confirm.callback) this[this.confirm.callback]()
      this.confirm.dialog = false
      this.confirm.callback = null
    },
    _cbAddPerioada () {
      this.openPerioadaDialog()
      this.perioada.type = 'add'
    },
    _cbUpdatePerioada () {
      this.openPerioadaDialog()
      this.perioada.type = 'update'

      const perioada = this.perioadeTabs[this.selectedPerioadeTab]
      const parts = perioada.label.split('-')
      const quarter = +parts[1][1]
      // transform 1,2,3,4 into 3,6,9,12
      const month = (quarter - 1) * 3 + 3

      this.$set(this.perioada.values, 'quarter', `${parts[0]}-${String(month).padStart(2, '0')}`)
    },
    _cbClosePerioadaDialog () {
      this.perioada.dialog = false
      this.$set(this.perioada.values, 'quarter', null)
      this.$set(this.perioada, 'type', null)
      this.$set(this.perioada.values, 'preluare', true)
      this.$set(this.perioada.values, 'automation', true)
      this.$set(this.perioada.values, 'parse', true)
      this.$set(this.perioada.values, 'compute', true)
      this.$set(this.perioada.values, 'reports', true)
      this.$set(this.perioada.values, 'skipExisting', true)
    },
    _cbSavePerioada () {
      const parts = this.perioada.values.quarter.split('-')
      const year = parts[0]
      const quarter = Math.ceil(((+parts[1]) / 3))

      if (this.perioada.type === 'add') {
        this.addPerioada(year, quarter)
      } else if (this.perioada.type === 'update') {
        this.updatePerioada(year, quarter)
      }

      this._cbClosePerioadaDialog()
    },

    addPerioada (year, quarter) {
      this.$store.dispatch(`${this.type}/savePerioada`, {
        label: `${year}-T${quarter}`,
        date: `${this.perioada.values.quarter}-01`,
        preluare: this.perioada.values.preluare,
        automation: this.perioada.values.automation,
        parse: this.perioada.values.parse,
        compute: this.perioada.values.compute,
        reports: this.perioada.values.reports
      })
    },

    allowedMonths (val) {
      const parts = val.split('-')
      const isAllowedMonth = parseInt(parts[1], 10) % 3 === 0
      const quarter = (Math.floor((+parts[1] - 1) / 3)) + 1
      const formatted = `${parts[0]}-T${quarter}`
      let duplicate = this.perioadeTabs.find((perioada, index) => {
        if (this.perioada.type === 'edit' && index === this.selectedPerioadeTab) return false
        return perioada.label === formatted
      })

      return isAllowedMonth && !duplicate
    },
    dateToQuarter (date) {
      const month = date.split('-')[1]
      return `Trimestrul ${(+month / 3)}`
    },
    openPerioadaDialog () {
      this.perioada.dialog = true
    },

    updatePerioada (year, quarter) {
      const perioada = this.perioadeTabs[this.selectedPerioadeTab]

      this.$store.dispatch('automation/updatePerioada', {
        label: `${year}-T${quarter}`,
        id: perioada._id,
        actions: {
          download: this.perioada.values.automation,
          parse: this.perioada.values.parse,
          compute: this.perioada.values.compute,
          reports: this.perioada.values.reports,
          skipExisting: this.perioada.values.skipExisting
        }
      })
    }
  },
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchHeaders`)
    this.$store.dispatch(`${this.type}/fetchItems`)
    this.$store.dispatch(`${this.type}/fetchPerioadeTabs`)
  }
}
</script>

<style>

</style>
